import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import VoiceAgent from "@/components/voice/VoiceAgent";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      <VoiceAgent />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
